module.exports = __webpack_public_path__ + "static/media/icon_sq.ea404465.png";